export type CurrencyCode = 'RUB' | 'UZS';

export interface CurrencyConfig {
  code: CurrencyCode;
  symbol: string;
  decimals: number;
}

export const CURRENCIES: Record<CurrencyCode, CurrencyConfig> = {
  RUB: { code: 'RUB', symbol: '₽', decimals: 2 },
  UZS: { code: 'UZS', symbol: 'сум', decimals: 0 },
};

/**
 * Форматирует сумму с учётом правил валюты (для UZS без тийинов, с разделением
 * тысяч). Пример: formatCurrency(15000, 'UZS') -> '15 000 сум';
 * formatCurrency(150.5, 'RUB') -> '150,50 ₽'.
 */
export function formatCurrency(amount: number, currency: CurrencyCode = 'RUB'): string {
  const config = CURRENCIES[currency] || CURRENCIES.RUB;
  const formattedNumber = new Intl.NumberFormat('ru-RU', {
    minimumFractionDigits: config.decimals,
    maximumFractionDigits: config.decimals,
  }).format(amount);
  return `${formattedNumber} ${config.symbol}`;
}
